export default {
  "uploadWrapper": "_uploadWrapper_13g6a_1",
  "input": "_input_13g6a_11"
};import "ni:sha-256;VL9VH_6eqYIds5Dnt2n8X5cnzCP7Wtxty-FUSTa3qX4";